<template>
  <div>
    <div class="mdn-Row">
      <div class="mdn-Col-lg mb-5">
        <h2 class="mdn-Heading mdn-Heading--sm">Mais Vantagens</h2>
      </div>
      <div class="mdn-Col-lg-12">
        <!-- Snippet start -->
        <div
          class="mdn-Swiper"
          data-mdn-slider-per-view-mobile="auto"
          data-mdn-slider-per-view-tablet="auto"
          data-mdn-slider-per-view-small-desktop="auto"
          data-mdn-slider-per-view="auto"
          id="swiperHome"
        >
          <div class="mdn-Swiper-wrapper">
            <div class="mdn-Swiper-slide">
              <CardSmall
                tabindex="0"
                :titulo="'Sem fidelidade'"
                :icon="'mdn-Icon-bloqueio mdn-Icon--md'"
                :title="
                  String($t('accessibilityTexts.title.swiper.noFidelity'))
                "
                @click.native="go(0)"
                @keyup.enter.native="go(0)"
                :class="index === 0 ? 'active' : ''"
              ></CardSmall>
            </div>
            <div class="mdn-Swiper-slide">
              <CardSmall
                tabindex="0"
                :titulo="'Indique e ganhe'"
                :icon="'mdn-Icon-beneficios mdn-Icon--md'"
                :title="
                  String($t('accessibilityTexts.title.swiper.referAndWin'))
                "
                @click.native="go(2)"
                @keyup.enter.native="go(2)"
                :class="index === 2 ? 'active' : ''"
              ></CardSmall>
            </div>
            <div class="mdn-Swiper-slide">
              <CardSmall
                tabindex="0"
                :titulo="'Pagamento fácil'"
                :icon="'mdn-Icon-debito-automatico mdn-Icon--md'"
                :title="
                  String($t('accessibilityTexts.title.swiper.easyPayment'))
                "
                @click.native="go(3)"
                @keyup.enter.native="go(3)"
                :class="index === 3 ? 'active' : ''"
              ></CardSmall>
            </div>
            <div class="mdn-Swiper-slide">
              <CardSmall
                tabindex="0"
                :titulo="'Ligações ilimitadas'"
                :icon="'mdn-Icon-telefone-fixo mdn-Icon--md'"
                :title="
                  String($t('accessibilityTexts.title.swiper.unlimitedCalls'))
                "
                @click.native="go(4)"
                @keyup.enter.native="go(4)"
                :class="index === 4 ? 'active' : ''"
              ></CardSmall>
            </div>
          </div>

          <div class="mdn-Swiper-pagination-custom">
            <!-- Add Arrows -->
            <div class="mdn-Swiper-button-prev">
              <i class="mdn-Icon-esquerda mdn-Icon--lg"></i>
            </div>
            <div class="mdn-Swiper-button-next">
              <i class="mdn-Icon-direita mdn-Icon--lg"></i>
            </div>
          </div>
        </div>
        <!-- Snippet end -->
      </div>
    </div>

    <div class="mdn-Row itens">
      <div class="mdn-Col-lg-12 item" v-show="index === 0">
        <h2 class="mdn-Subtitle mdn-Subtitle--xs">Sem fidelidade</h2>
        <p class="mdn-Text mdn-Text--body mt-3">
          Sem taxas e você pode cancelar quando quiser.
        </p>
      </div>
      <div class="mdn-Col-lg-12 item" v-show="index === 2">
        <h2 class="mdn-Subtitle mdn-Subtitle--xs">Indique e ganhe</h2>
        <p class="mdn-Text mdn-Text--body mt-3">
          Convide seus amigos para o Claro flex e ganhe
          {{ this.valorBonus }} por cada indicação efetivada. Seus amigos também
          ganham {{ this.valorBonus }} cada e você pode convidar quantas pessoas
          quiser.
        </p>
      </div>
      <div class="mdn-Col-lg-12 item" v-show="index === 3">
        <h2 class="mdn-Subtitle mdn-Subtitle--xs">Pagamento fácil</h2>
        <p class="mdn-Text mdn-Text--body mt-3">
          Pague com recarga, PIX, cartão de crédito ou débito virtual da Caixa.
          Sem fidelidade.
        </p>
      </div>
      <div class="mdn-Col-lg-12 item" v-show="index === 4">
        <h2 class="mdn-Subtitle mdn-Subtitle--xs">Ligações ilimitadas</h2>
        <p class="mdn-Text mdn-Text--body mt-3">
          Ligações ilimitadas para qualquer operadora do Brasil.
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";

import { Component, Prop } from "vue-property-decorator";

import CardSmall from "@/components/core/CardSmall.vue";
import { pushTagEvent } from "@/helpers/Gtm/gaExecuteEvents";
import { EVENT_NAME } from "@/helpers/Gtm/events";

@Component({
  name: "Swiper",
  components: {
    CardSmall,
  },
})
export default class Swiper extends Vue {
  @Prop({ default: "4GB de bônus" }) readonly valorBonus!: string;

  index = 0;

  go(param: number) {
    const win = window as any;

    this.index = param;

    let tag = "";
    let eventName = null;

    switch (param) {
      case 0:
        tag = "sem-fidelidade";
        eventName = EVENT_NAME.BTN_SEM_FIDELIDADE;
        break;
      case 1:
        tag = "apps-ilimitados";
        eventName = EVENT_NAME.BTN_APPS_ILIMITADOS;
        break;
      case 2:
        tag = "bonus-internet";
        eventName = EVENT_NAME.BTN_INDIQUE_E_GANHE;
        break;
      case 3:
        tag = "pagamento-recarga";
        eventName = EVENT_NAME.BTN_PAGAMENTO_FACIL;
        break;
      case 4:
        tag = "ligacoes-ilimitadas";
        eventName = EVENT_NAME.BTN_LIGACOES_ILIMITADAS;
        break;
      default:
        break;
    }

    if (eventName) {
      pushTagEvent({ eventName });
    }

    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:card",
        eventLabel: `${tag}`,
      });
    }
  }
}
</script>
<style scoped>
.itens {
  height: 200px;
}
</style>
